/**
 * ReportStream entity class
 */

/**
 * ReportStreamFactory
 * returns ReportStream entity class
 *
 * @class ReportStreamFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportStream} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportStreamFactory
 */
/* @ngInject */
export default function ReportStreamFactory (Report) {
  /* === ReportStream class === */

  /**
   * ReportStream model
   *
   * @class ReportStream
   * @classdesc ReportStream model
   * @memberof models
   * @see models
   * @extends models.Report
   * @param {Object} [object] - initial object, containing ReportStream entity fields
   * @return {models.ReportStream} ReportStream entity
   */
  function ReportStream () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportStream.prototype = Object.create(Report.prototype)
  ReportStream.prototype.constructor = ReportStream

  /* === User instance methods & fields === */

  Object.assign(ReportStream.prototype, {

    /**
     * url template
     *
     * @memberof models.ReportStream#
     * @type {String}
     */
    _urlTemplate: 'api/reports/streams/{{::id}}'

  })

  /* === User static methods & fields === */

  // copy all static methods from ReportStream class
  Object.assign(ReportStream, Report)
  ReportStream._name = 'ReportStream'
  ReportStream.init()

  // permissions
  // ReportStream.access = {
  //   view: 'viewReport',
  //   delete: 'deleteReport'
  // }

  return ReportStream
}
